import type { JSX } from 'react';
import { useIntl } from '@doxyme/locale';
import {
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  Illustration,
} from '@doxyme/ui/components/foundations';
import { Icon } from '@doxyme/icons';
import { UpsellCard } from '../../../upgrade/upsellCard';
import { useInviteViaTextMessageFreeModalContentStyles } from './inviteViaTextMessageFreeModalContent.styles';
import { useUserSubscription } from '../../../../hooks/useUserSubscription';

export type InviteViaTextMessageFreeModalContentProps = {
  closeModal: () => void;
  onUpgradeSubscription: () => void;
  titleId?: string;
};

export const InviteViaTextMessageFreeModalContent = ({
  closeModal,
  onUpgradeSubscription,
  titleId,
}: InviteViaTextMessageFreeModalContentProps): JSX.Element => {
  const { formatMessage } = useIntl();
  const styles = useInviteViaTextMessageFreeModalContentStyles();
  const { isUpgradeButtonVisible } = useUserSubscription();

  return (
    <ModalContent>
      <ModalHeader
        title={formatMessage({ id: 'inviteViaTextMessage' })}
        titleId={titleId}
        onClose={closeModal}
      />

      <ModalBody withFooter={isUpgradeButtonVisible}>
        <UpsellCard
          image={<Illustration.TextMessage />}
          imageSize={styles.upsellCardImageSize}
          content={[
            {
              icon: <Icon.Padlock type='filled' />,
              title: 'inviteViaTextMessage.maintainYourPrivacyTitle',
              description:
                'inviteViaTextMessage.maintainYourPrivacyDescription',
            },
            {
              icon: <Icon.Clock type='filled' />,
              title: 'inviteViaTextMessage.saveTimeTitle',
              description: 'inviteViaTextMessage.saveTimeDescription',
            },
            {
              icon: <Icon.Phone type='filled' />,
              title: 'inviteViaTextMessage.reachYourPatientTitle',
              description: 'inviteViaTextMessage.reachYourPatientDescription',
            },
          ]}
        />
      </ModalBody>
      {isUpgradeButtonVisible && (
        <ModalFooter
          submitButton={{
            type: 'upgrade',
            onClick: onUpgradeSubscription,
            children: formatMessage({ id: 'inviteVia.upgrade' }),
          }}
        />
      )}
    </ModalContent>
  );
};
